__turbopack_context__.v({
  "card": "LmwKPq_card",
  "cardLink": "LmwKPq_cardLink",
  "content": "LmwKPq_content",
  "image": "LmwKPq_image",
  "imageWrapper": "LmwKPq_imageWrapper",
  "ratings": "LmwKPq_ratings",
  "removeButton": "LmwKPq_removeButton",
  "usps": "LmwKPq_usps",
});
